export const isNullOrUndefined = (val) => val === null || val === undefined;





